import { useMemo } from "react";
import { getAssetUrl } from "@/utils/helpers";
import type { EnumTransactionTimelineStepStatus } from "@/api/cashier";

const STATUS_ICON_FOLDER = "icons/statuses";

/* The useStatusIcon hook
  This hook returns the URL of the status icon based on the transaction timeline step status.
  @param status - The status of the transaction timeline step.
  @returns A string representing the URL of the status icon.
*/
export const useStatusIcon = (status: EnumTransactionTimelineStepStatus) => {
  return useMemo(() => {
    switch (status) {
      case "not_started":
        return getAssetUrl("not_started.svg", STATUS_ICON_FOLDER);
      case "in_progress":
        return getAssetUrl("in_progress.svg", STATUS_ICON_FOLDER);
      case "completed":
        return getAssetUrl("completed.svg", STATUS_ICON_FOLDER);
      case "failed":
        return getAssetUrl("failed.svg", STATUS_ICON_FOLDER);
      case "cancelled":
        return getAssetUrl("cancelled.svg", STATUS_ICON_FOLDER);
      default:
        return getAssetUrl("not_started.svg", STATUS_ICON_FOLDER);
    }
  }, [status]);
};
